export function formatCurrency(value: number) {
  return `$${Number.isInteger(value) ? value : value.toFixed(2)}`
}
